import { ErrorBlock } from '@/components/common/ErrorBlock'
import { PreconCard } from '@/components/common/PreconCard'
import { usePage } from '@/components/providers/PageProvider'
import { cn } from '@/utils/commonUtil'

import styles from './FeaturedRecPrecon.module.scss'

export const FeaturedRecPrecon = () => {
  const { page } = usePage()
  const rec = page?.featured?.rec
  const { image } = page?.featured?.precon || {}

  if (!rec) return <ErrorBlock />

  return (
    <div className={cn(styles.container, { hasImage: !!image, styles })}>
      <PreconCard image={image} rec={rec} />
    </div>
  )
}
